/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartPrescriptionsAliases {
  CONTEXTUAL_BAR_MEDICAL_AREA = 'contextual-bar-medical-area',
  DECK_PRESCRIPTIONS = 'deck-prescriptions',
  FETCH_PRESCRIPTIONS = 'fetch-prescriptions',
  LAYOUT_MY_CHART_PRESCRIPTIONS = 'layout-my-chart-prescriptions',
  PANEL_GENERAL = 'panel-general',
  PRESCRIPTIONS_CARD = 'prescriptions-card',
}
export { MyChartPrescriptionsAliases };
